import { render, staticRenderFns } from "./unsubscribe.vue?vue&type=template&id=d00fbf2a&"
import script from "./unsubscribe.vue?vue&type=script&lang=js&"
export * from "./unsubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports